import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { i18n } from 'utils/i18n';

const LoadingWidget = ({
  darkTheme = false,
  animatedComponentLoading = false,
  loading = false,
  loadingContent = null,
}) => {
  const loaderRef = useRef(null);

  useEffect(() => {
    if (loading) {
      loaderRef?.current?.focus();
    }
    // Save the currently focused element when the loader unmounts
    loaderRef.current = document.activeElement;

    return () => {
      // Restore focus to the previously focused element when the loading unmounts
      if (loaderRef.current && document.body.contains(loaderRef.current)) {
        loaderRef.current.focus();
      }
    };
  }, []);

  // Dynamically setting the aria-label message to announce the loading state message for screenreaders
  let content = loading ? i18n('wcag_loading') : i18n('wcag_loaded');
  if (loading && loadingContent) {
    content = loadingContent;
  }

  //
  return (
    <div
      className={cn('loading-widget', {
        'loading-widget--dark-theme': darkTheme,
        'loading-widget--animated': animatedComponentLoading,
      })}
    >
      <div
        className='vis-hidden' // vis hidding content , and ensuring the  content is being read correctly for screenreaders as
        ref={loaderRef}
        role='status'
        aria-label={content}
        tabIndex={-1} // -1 allows programmatic focus but removes it from the natural tab order
      >
        {content}
      </div>
    </div>
  );
};

LoadingWidget.propTypes = {
  darkTheme: PropTypes.bool,
};

export default LoadingWidget;
